import React, { useEffect, useState } from "react";
import {
  transformResultsToCompProfileData,
  formatBoldText,
} from "../../../../../services/commonService";
import InsightTable from "../../InsightTable";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";
import { useParams } from "react-router-dom";

function DemandGenerationAndAcquisistionTactics({
  demandGenerationAndAcquisitionTactics = [],
  compView,
}) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");
  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const { clientName, competitorName } = useParams();
  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        // { key: "tactic_type", label: "Tactic Type" },
        { key: "reach_scale", label: "Reach Scale" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        // { key: "tactic_type", label: "Tactic Type" },
        { key: "insight", label: "Insight" },
        { key: "reach_scale", label: "Reach Scale" },
        { key: "effectiveness_signal", label: "Effectiveness Signal" },
        { key: "estimated_cac", label: "Estimated CAC" },
      ];

      setColumns(allMetrics);
      setHiddenColumns(["estimated_cac"]);
      setSidebarColumns([]);
    }
  }, [compView]);

  {
    /*  const dummyData = [
    {
      region: "North America",
      primary_channel: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Derived",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_positive_insight: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_negative_insight: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      primary_channel_recent_development: {
        value: "Direct",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Derived from partner onboarding documentation.",
      },
      sales_motion: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Based on vendor product classification.",
      },
      sales_motion_positive_insight: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Customer satisfaction surveys.",
      },
      sales_motion_negative_insight: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "No ambulatory offerings available.",
      },
      sales_motion_recent_development: {
        value: "Solution Selling",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.8,
        reasoning: "Confirmed in feature update report.",
      },
      focus_area: {
        value: "High",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.9,
        reasoning: "Measured by deployment across all departments.",
      },
      focus_area_positive_insight: {
        value: "Fully integrated across EMR and billing.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.85,
        reasoning: "Feedback from implementation teams.",
      },
      focus_area_negative_insight: {
        value: "Integration delays in 2 sites.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.7,
        reasoning: "Deployment status reports.",
      },
      focus_area_recent_development: {
        value: "Resolved API issues in July.",
        source: "https://placeholder.source.com",
        data_type: "Qualitative",
        confidence_score: 0.75,
        reasoning: "Engineering resolution ticket logged.",
      },
    },
  ]; */
  }

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(
      demandGenerationAndAcquisitionTactics
    );
    setTabData(transformed);
    setTableBelowDescription(
      // formatBoldText(
      //   demandGenerationAndAcquisitionTactics?.[0]?.response?.tableComments
      // )
      <ParsedTextWithLinks
        text={
          demandGenerationAndAcquisitionTactics?.[0]?.response?.tableComments ||
          ""
        }
      />
    );
    // console.log("DEMAND: " + JSON.stringify(transformed));
    // setTabData(dummyData);
  }, [demandGenerationAndAcquisitionTactics]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Demand Generation & Acquisition Tactics"
      subtitle={`How ${
        competitorName ?? "Tailored Chemical"
      } brings customers into its pipeline.`}
      belowTableDescription={tableBelowDescription}
      data={tabData}
      hiddenColumns={hiddenColumns}
      metrics={columns}
      rowIdentifier="tactic_type"
      actions={actions}
    />
  );
}

export default DemandGenerationAndAcquisistionTactics;
